import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { findSysDictionary } from '@/api/sysDictionary';
export var dictionary = {
  namespaced: true,
  state: {
    dictionaryMap: {}
  },
  mutations: {
    setDictionaryMap: function setDictionaryMap(state, dictionaryMap) {
      state.dictionaryMap = _objectSpread(_objectSpread({}, state.dictionaryMap), dictionaryMap);
    }
  },
  actions: {
    // 从后台获取动态路由
    getDictionary: function getDictionary(_ref, type) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, state, res, dictionaryMap, dict;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, state = _ref.state;

                if (!state.dictionaryMap[type]) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", state.dictionaryMap[type]);

              case 5:
                _context.next = 7;
                return findSysDictionary({
                  type: type
                });

              case 7:
                res = _context.sent;

                if (!(res.code === 0)) {
                  _context.next = 15;
                  break;
                }

                dictionaryMap = {};
                dict = [];
                res.data.resysDictionary.sysDictionaryDetails && res.data.resysDictionary.sysDictionaryDetails.map(function (item) {
                  dict.push({
                    ID: item.ID,
                    label: item.label,
                    value: item.value
                  });
                });
                dictionaryMap[res.data.resysDictionary.type] = dict;
                commit('setDictionaryMap', dictionaryMap);
                return _context.abrupt("return", state.dictionaryMap[type]);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    getDictionary: function getDictionary(state) {
      return state.dictionaryMap;
    }
  }
};